// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-section {
    background-color: #191a1a;
    width: 100%;
    height: 100vh;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.search-section-content {
    width: 800px;
    transform: translateY(-120px); 
}

.search-section-title {
    color: #e8e8e6;
    font-size: 24px;
    font-weight: 600;
    font-family: monospace;
}

`, "",{"version":3,"sources":["webpack://./src/components/SearchSection.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;;IAEb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B","sourcesContent":[".search-section {\n    background-color: #191a1a;\n    width: 100%;\n    height: 100vh;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.search-section-content {\n    width: 800px;\n    transform: translateY(-120px); \n}\n\n.search-section-title {\n    color: #e8e8e6;\n    font-size: 24px;\n    font-weight: 600;\n    font-family: monospace;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
